import { Image, Text } from '@wix/design-system';
import React, { FC } from 'react';
import styles from './ProductCard.scss';
import { CartSmall } from '@wix/wix-ui-icons-common';
import clsx from 'clsx';

type Props = {
  imageUrl: string;
  name: string;
  isLoading?: boolean;
  buyButtonText?: string;
};

export const ProductCard: FC<Props> = ({ imageUrl, name, buyButtonText, isLoading }) => {
  const buyLabel = buyButtonText?.trim() ?? '';

  return (
    <div className={styles.productCard}>
      <div className={styles.productCardImageWrapper}>
        <Image transparent className={clsx(styles.productCardImage, isLoading && styles.loading)} src={imageUrl} />
      </div>
      <div className={styles.productCardContent}>
        <Text size="tiny" weight="bold">
          {name}
        </Text>

        {buyLabel ? (
          <div className={styles.productCardBuyButton}>
            <CartSmall />
            <span>{buyLabel}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};
